import React, { useState } from "react";

import { Dataset } from "components/dashboard/dataset-window/models/types";
import { removeItemById } from "components/dashboard/dataset-window/utils/utils";
import { ListBox } from "primereact/listbox";
import DatasetView from "components/dashboard/dataset-window/DatasetView";
import { DatasetInfo } from "api/model/dataset/DatasetInfo";

type DatasetsTabProps = {
  datasets: DatasetInfo[] | undefined
}

const DatasetsTab: React.FC<DatasetsTabProps> = ({ datasets }) => {
  const [selectedDatasets, setSelectedDatasets] = useState<Dataset[]>([]);

  if (!datasets || datasets?.length === 0) return <span>No datasets are linked</span>;
  
  const removeDataset = (removedId: string) => {
      setSelectedDatasets(removeItemById(selectedDatasets, removedId))
  }

  const formattedData = datasets?.map(dataset => ({...dataset, formatedTitle: dataset?.title, group: dataset.groupTitle}))
  return (
    <div className="w-full mt-3 flex" style={{ minHeight: "700px"}}>
      <ListBox
        value={selectedDatasets}
        options={formattedData ?? []}
        onChange={e => setSelectedDatasets(e.value)}
        placeholder="Datasets"
        optionLabel="title"
        className="p-inputtext-sm m-2"
        multiple
        filter
      />
      <DatasetView selectedDatasetsID={selectedDatasets} removeDataset={removeDataset} setSelectedDatasets={setSelectedDatasets}/>
    </div>
  );
}

export default DatasetsTab;